import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class FilingRejectReasonApi<FilingRejectReason> extends BaseAPI {
  public getFilingRejectReasons: () => Promise<FilingRejectReason[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/FilingRejectReason`)).data.output;
  };

  public getFilingRejectReasonById: (id: number) => Promise<FilingRejectReason> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/FilingRejectReason/${id}`)).data.output;
  }
}

export const filingRejectReasonAPI = new FilingRejectReasonApi();
